<template>
  <div class="whatsapp-config-container">
    <!-- ✅ HEADER DA PÁGINA -->
    <div class="page-header">
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-avatar size="48" color="green-darken-1" class="mr-4">
            <v-icon color="white" size="28">mdi-whatsapp</v-icon>
          </v-avatar>
          <div>
            <h1 class="text-h4 font-weight-bold text-green-darken-1">WhatsApp Config</h1>
            <p class="text-subtitle-1 text-grey-darken-1 mb-0">
              Configure e gerencie sua instância do WhatsApp
            </p>
          </div>
        </div>
        
        <!-- Botão Voltar -->
        <v-btn
          color="grey"
          variant="outlined"
          @click="voltaraomenu"
          class="back-btn"
        >
          <v-icon start>mdi-arrow-left</v-icon>
          Voltar ao Menu
        </v-btn>
      </div>
    </div>

    <!-- ✅ CARDS CORRIGIDOS - SEM REDUNDÂNCIA -->
    <v-card class="main-card" elevation="2">
      <v-card-title class="bg-green-lighten-5 pa-4">
        <v-icon class="mr-2" color="green-darken-1">mdi-cog</v-icon>
        Ações da Instância WhatsApp
      </v-card-title>
      
      <v-card-text class="pa-6">
        <v-row>
          <!-- ✅ 1. VERIFICAR STATUS (sempre visível) -->
          <v-col cols="12" md="6">
            <v-card 
              class="action-card status-card" 
              variant="outlined"
              @click="verificarStatus"
              :loading="loadingDialog && mensagemDialog === 'Verificando Status...'"
            >
              <v-card-text class="text-center pa-4">
                <v-avatar size="48" color="info" variant="tonal" class="mb-3">
                  <v-icon size="28" color="info">mdi-check-circle</v-icon>
                </v-avatar>
                <div class="text-h6 font-weight-bold mb-2">Verificar Status</div>
                <div class="text-caption text-grey">
                  Consulte o status atual da conexão
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- ✅ 2. CARD CONDICIONAL (muda conforme status) -->
          <v-col cols="12" md="6" lg="4">
            <!-- 🟢 Se CONECTADO: mostrar DESCONECTAR -->
            <v-card 
              v-if="retornoApi?.statusConexao === 'open'"
              class="action-card disconnect-card" 
              variant="outlined"
              @click="desconectarInstancia"
              :loading="loadingDialog && mensagemDialog.includes('Desconectando')"
            >
              <v-card-text class="text-center pa-4">
                <v-avatar size="48" color="warning" variant="tonal" class="mb-3">
                  <v-icon size="28" color="warning">mdi-power-plug-off</v-icon>
                </v-avatar>
                <div class="text-h6 font-weight-bold mb-2">Desconectar</div>
                <div class="text-caption text-grey">
                  Desconecte para gerar novo QR Code
                </div>
              </v-card-text>
            </v-card>

            <!-- 🔴 Se DESCONECTADO: mostrar GERAR QR CODE -->
            <v-card 
              v-else-if="retornoApi?.statusConexao === 'close'"
              class="action-card qr-card" 
              variant="outlined"
              @click="gerarQRCode"
              :loading="loadingDialog && mensagemDialog.includes('QR Code')"
            >
              <v-card-text class="text-center pa-4">
                <v-avatar size="48" color="success" variant="tonal" class="mb-3">
                  <v-icon size="28" color="success">mdi-qrcode</v-icon>
                </v-avatar>
                <div class="text-h6 font-weight-bold mb-2">Gerar QR Code</div>
                <div class="text-caption text-grey">
                  Conecte seu WhatsApp escaneando
                </div>
              </v-card-text>
            </v-card>

            <!-- 🟡 Se CONECTANDO: mostrar AGUARDAR -->
            <v-card 
              v-else-if="retornoApi?.statusConexao === 'connecting'"
              class="action-card connecting-card" 
              variant="outlined"
              disabled
            >
              <v-card-text class="text-center pa-4">
                <v-avatar size="48" color="warning" variant="tonal" class="mb-3">
                  <v-icon size="28" color="warning">mdi-loading mdi-spin</v-icon>
                </v-avatar>
                <div class="text-h6 font-weight-bold mb-2">Conectando...</div>
                <div class="text-caption text-grey">
                  Aguarde a conexão ser estabelecida
                </div>
              </v-card-text>
            </v-card>

            <!-- ⚪ ESTADO PADRÃO: mostrar GERAR QR CODE -->
            <v-card 
              v-else
              class="action-card qr-card" 
              variant="outlined"
              @click="gerarQRCode"
              :loading="loadingDialog && mensagemDialog.includes('QR Code')"
            >
              <v-card-text class="text-center pa-4">
                <v-avatar size="48" color="success" variant="tonal" class="mb-3">
                  <v-icon size="28" color="success">mdi-qrcode</v-icon>
                </v-avatar>
                <div class="text-h6 font-weight-bold mb-2">Gerar QR Code</div>
                <div class="text-caption text-grey">
                  Conecte seu WhatsApp escaneando
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- ✅ AÇÕES ADICIONAIS -->
        <v-row class="mt-4">
          <!-- Resetar Instância -->
          <v-col cols="12" md="6">
            <v-card 
              class="action-card reset-card" 
              variant="outlined"
              @click="resetarInstancia"
              :loading="loadingDialog && mensagemDialog.includes('Resetando')"
            >
              <v-card-text class="text-center pa-3">
                <div class="d-flex align-center justify-center">
                  <v-avatar size="32" color="orange" variant="tonal" class="mr-3">
                    <v-icon size="18" color="orange">mdi-restart</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-subtitle-1 font-weight-bold">Resetar Instância</div>
                    <div class="text-caption text-grey">
                      Desconectar e gerar novo QR Code
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Enviar Mensagem de Teste -->
          <v-col cols="12" md="6">
            <v-card 
              class="action-card test-message-card" 
              variant="outlined"
              @click="abrirDialogMensagemTeste"
              :disabled="retornoApi?.statusConexao !== 'open'"
            >
              <v-card-text class="text-center pa-3">
                <div class="d-flex align-center justify-center">
                  <v-avatar size="32" color="purple" variant="tonal" class="mr-3">
                    <v-icon size="18" color="purple">mdi-message-text</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-subtitle-1 font-weight-bold">Enviar Mensagem de Teste</div>
                    <div class="text-caption text-grey">
                      {{ retornoApi?.statusConexao === 'open' ? 'Testar envio de mensagem' : 'Conecte primeiro' }}
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- ✅ CARD MELHORADO PARA INSTÂNCIAS -->
    <v-card v-if="retornoApi && retornoApi.instancias" class="instances-display-card mt-6" elevation="3">
      <v-card-title class="bg-blue-lighten-5 pa-4">
        <v-icon class="mr-2" color="blue-darken-1">mdi-server-network</v-icon>
        Instâncias WhatsApp Disponíveis
        <v-spacer></v-spacer>
        <v-chip 
          color="blue" 
          size="small" 
          variant="elevated"
        >
          {{ retornoApi.instancias.length }} instância(s)
        </v-chip>
      </v-card-title>
      
      <v-card-text class="pa-4">
        <v-row>
          <v-col 
            v-for="(instancia, index) in retornoApi.instancias" 
            :key="index"
            cols="12" sm="6" md="4" lg="3"
          >
            <v-card 
              class="instance-card" 
              variant="outlined"
              :class="getInstanceCardClass(instancia.state)"
            >
              <!-- Header da Instância -->
              <v-card-title class="pa-3 pb-2">
                <div class="d-flex align-center justify-space-between w-100">
                  <div class="d-flex align-center">
                    <v-avatar 
                      size="32" 
                      :color="getInstanceColor(instancia.state)" 
                      variant="tonal"
                      class="mr-2"
                    >
                      <v-icon 
                        size="18" 
                        :color="getInstanceColor(instancia.state)"
                      >
                        {{ getInstanceIcon(instancia.state) }}
                      </v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-subtitle-2 font-weight-bold">
                        {{ instancia.instanceName || `Instância ${index + 1}` }}
                      </div>
                    </div>
                  </div>
                  
                  <!-- Status Chip -->
                  <v-chip 
                    :color="getInstanceColor(instancia.state)" 
                    size="x-small"
                    variant="elevated"
                  >
                    {{ getInstanceStatusText(instancia.state) }}
                  </v-chip>
                </div>
              </v-card-title>

              <!-- Conteúdo da Instância -->
              <v-card-text class="pa-3 pt-0">
                <v-list density="compact" class="pa-0">
                  <!-- Estado -->
                  <v-list-item class="pa-1">
                    <template v-slot:prepend>
                      <v-icon size="16" color="grey">mdi-state-machine</v-icon>
                    </template>
                    <v-list-item-title class="text-caption">
                      <strong>Estado:</strong> {{ instancia.state || 'N/A' }}
                    </v-list-item-title>
                  </v-list-item>

                  <!-- ID da Instância -->
                  <v-list-item v-if="instancia.instanceId" class="pa-1">
                    <template v-slot:prepend>
                      <v-icon size="16" color="grey">mdi-identifier</v-icon>
                    </template>
                    <v-list-item-title class="text-caption">
                      <strong>ID:</strong> {{ instancia.instanceId }}
                    </v-list-item-title>
                  </v-list-item>

                  <!-- Servidor -->
                  <v-list-item v-if="instancia.serverUrl" class="pa-1">
                    <template v-slot:prepend>
                      <v-icon size="16" color="grey">mdi-server</v-icon>
                    </template>
                    <v-list-item-title class="text-caption">
                      <strong>Servidor:</strong> {{ formatServerUrl(instancia.serverUrl) }}
                    </v-list-item-title>
                  </v-list-item>

                  <!-- Número do WhatsApp -->
                  <v-list-item v-if="instancia.number" class="pa-1">
                    <template v-slot:prepend>
                      <v-icon size="16" color="grey">mdi-phone</v-icon>
                    </template>
                    <v-list-item-title class="text-caption">
                      <strong>Número:</strong> {{ formatPhoneNumber(instancia.number) }}
                    </v-list-item-title>
                  </v-list-item>

                  <!-- Status de Conexão -->
                  <v-list-item v-if="instancia.connectionStatus" class="pa-1">
                    <template v-slot:prepend>
                      <v-icon size="16" color="grey">mdi-connection</v-icon>
                    </template>
                    <v-list-item-title class="text-caption">
                      <strong>Conexão:</strong> {{ instancia.connectionStatus }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>

                <!-- Ações da Instância -->
                <div class="mt-3">
                  <v-btn 
                    v-if="instancia.state === 'close'"
                    size="small" 
                    color="success" 
                    variant="tonal"
                    block
                    @click="conectarInstancia(instancia)"
                  >
                    <v-icon start size="16">mdi-qrcode</v-icon>
                    Conectar
                  </v-btn>
                  
                  <v-btn 
                    v-else-if="instancia.state === 'open'"
                    size="small" 
                    color="warning" 
                    variant="tonal"
                    block
                    @click="desconectarInstanciaEspecifica(instancia)"
                  >
                    <v-icon start size="16">mdi-power-plug-off</v-icon>
                    Desconectar
                  </v-btn>
                  
                  <v-btn 
                    v-else
                    size="small" 
                    color="info" 
                    variant="tonal"
                    block
                    @click="verificarStatusInstancia(instancia)"
                  >
                    <v-icon start size="16">mdi-refresh</v-icon>
                    Atualizar
                  </v-btn>
                </div>
              </v-card-text>

              <!-- Footer com Timestamp -->
              <v-card-actions v-if="instancia.lastUpdate" class="pa-2 pt-0">
                <v-spacer></v-spacer>
                <div class="text-caption text-grey">
                  <v-icon size="12" class="mr-1">mdi-clock-outline</v-icon>
                  {{ formatTimestamp(instancia.lastUpdate) }}
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <!-- Mensagem quando não há instâncias -->
        <div v-if="!retornoApi.instancias || retornoApi.instancias.length === 0" class="text-center pa-6">
          <v-avatar size="64" color="grey-lighten-3" class="mb-3">
            <v-icon size="32" color="grey">mdi-server-off</v-icon>
          </v-avatar>
          <div class="text-h6 text-grey mb-2">Nenhuma instância encontrada</div>
          <div class="text-body-2 text-grey">
            Não há instâncias WhatsApp configuradas no momento.
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- ✅ RESULTADO DA API (para outras consultas) -->
    <v-card v-if="retornoApi && !retornoApi.instancias" class="result-card mt-6" elevation="2">
      <v-card-title class="bg-grey-lighten-4 pa-4">
        <v-icon class="mr-2" color="grey-darken-1">mdi-code-json</v-icon>
        Resultado da API
        <v-spacer></v-spacer>
        <v-btn 
          icon 
          size="small" 
          variant="text"
          @click="retornoApi = null"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text class="pa-4">
        <!-- Status da Instância (formato amigável) -->
        <div v-if="retornoApi.nomeInstancia" class="instance-status mb-4">
          <v-row>
            <v-col cols="12" md="6">
              <div class="status-item">
                <div class="text-caption text-grey">Nome da Instância</div>
                <div class="text-h6">{{ retornoApi.nomeInstancia }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="status-item">
                <div class="text-caption text-grey">Status da Conexão</div>
                <v-chip 
                  :color="getStatusColor(retornoApi.statusConexao)" 
                  size="small"
                  class="mt-1"
                >
                  <v-icon start size="16">{{ getStatusIcon(retornoApi.statusConexao) }}</v-icon>
                  {{ retornoApi.statusConexao }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- JSON Completo -->
        <v-expansion-panels v-if="retornoApi" variant="accordion">
          <v-expansion-panel>
            <v-expansion-panel-title>
              <v-icon class="mr-2">mdi-code-braces</v-icon>
              Ver JSON Completo
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-card variant="outlined" class="json-container">
                <v-card-text>
                  <pre class="json-content">{{ JSON.stringify(retornoApi, null, 2) }}</pre>
                </v-card-text>
              </v-card>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>

    <!-- ✅ MODAL DE CARREGAMENTO -->
    <v-dialog v-model="loadingDialog" persistent max-width="400">
      <v-card class="loading-card">
        <v-card-text class="text-center pa-6">
          <v-progress-circular 
            indeterminate 
            color="green-darken-1" 
            size="48"
            width="4"
            class="mb-4"
          ></v-progress-circular>
          <div class="text-h6 font-weight-medium mb-2">Processando...</div>
          <div class="text-body-2 text-grey">{{ mensagemDialog }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ✅ MODAL DO QR CODE -->
    <v-dialog v-model="qrCodeDialog" max-width="500" @keydown.esc="fecharQRCode">
      <v-card class="qr-modal">
        <v-card-title class="bg-success text-white pa-4">
          <v-icon class="mr-2">mdi-qrcode</v-icon>
          QR Code WhatsApp
          <v-spacer></v-spacer>
          <v-btn 
            icon 
            variant="text" 
            color="white"
            @click="fecharQRCode"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="text-center pa-6">
          <div v-if="qrCodeImage" class="qr-container">
            <img 
              :src="qrCodeImage" 
              alt="QR Code WhatsApp" 
              class="qr-image"
            />
            
            <v-alert 
              type="info" 
              variant="tonal" 
              class="mt-4"
              density="compact"
            >
              <v-icon start>mdi-information</v-icon>
              Escaneie o QR Code com seu WhatsApp
            </v-alert>
            
            <!-- Timer -->
            <div class="timer-section mt-4">
              <v-progress-linear
                :model-value="(tempoRestante / 60) * 100"
                color="success"
                height="8"
                rounded
                class="mb-2"
              ></v-progress-linear>
              <div class="text-caption text-grey">
                <v-icon size="16" class="mr-1">mdi-timer</v-icon>
                Expira em {{ tempoRestante }} segundos
              </div>
              
              <!-- Indicador de Verificação Automática -->
              <v-alert
                type="info"
                variant="tonal"
                density="compact"
                class="mt-3"
              >
                <div class="d-flex align-center">
                  <v-icon size="18" class="mr-2 mdi-spin">mdi-sync</v-icon>
                  <div class="text-caption">
                    Verificando conexão automaticamente a cada 10 segundos...
                  </div>
                </div>
              </v-alert>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ✅ MODAL DE MENSAGEM DE TESTE -->
    <v-dialog v-model="dialogMensagemTeste" max-width="600" persistent>
      <v-card>
        <v-card-title class="bg-purple-lighten-5 pa-4">
          <v-icon class="mr-2" color="purple">mdi-message-text</v-icon>
          Enviar Mensagem de Teste
          <v-spacer></v-spacer>
          <v-btn 
            icon 
            variant="text" 
            @click="fecharDialogMensagemTeste"
            :disabled="enviandoMensagem"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pa-6">
          <!-- Telefone -->
          <v-text-field
            v-model="mensagemTeste.telefone"
            label="Número do WhatsApp"
            placeholder="5581999999999"
            prepend-inner-icon="mdi-phone"
            hint="Digite o número com DDD (ex: 5581999999999)"
            persistent-hint
            variant="outlined"
            class="mb-4"
            :disabled="enviandoMensagem"
          ></v-text-field>

          <!-- Mensagem -->
          <v-textarea
            v-model="mensagemTeste.texto"
            label="Mensagem"
            placeholder="Digite sua mensagem de teste aqui..."
            prepend-inner-icon="mdi-message-text"
            rows="4"
            variant="outlined"
            counter
            :disabled="enviandoMensagem"
          ></v-textarea>

          <!-- Resultado do Envio -->
          <v-alert
            v-if="resultadoEnvio"
            :type="resultadoEnvio.tipo"
            variant="tonal"
            class="mt-4"
            closable
            @click:close="resultadoEnvio = null"
          >
            <div class="text-subtitle-2 font-weight-bold mb-1">
              {{ resultadoEnvio.titulo }}
            </div>
            <div class="text-body-2">
              {{ resultadoEnvio.mensagem }}
            </div>
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            variant="text"
            @click="fecharDialogMensagemTeste"
            :disabled="enviandoMensagem"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="purple"
            variant="elevated"
            @click="enviarMensagemTeste"
            :loading="enviandoMensagem"
            :disabled="!mensagemTeste.telefone || !mensagemTeste.texto"
          >
            <v-icon start>mdi-send</v-icon>
            Enviar Teste
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ✅ MODAL DE PROGRESSO DE ENVIO -->
    <v-dialog v-model="dialogProgressoEnvio" max-width="500" persistent>
      <v-card>
        <v-card-title class="bg-info-lighten-5 pa-4">
          <v-icon class="mr-2" color="info">mdi-send-clock</v-icon>
          Enviando Mensagem
        </v-card-title>
        
        <v-card-text class="pa-6">
          <div class="text-center">
            <v-progress-circular
              :model-value="progressoEnvio"
              :size="80"
              :width="8"
              color="info"
              class="mb-4"
            >
              {{ progressoEnvio }}%
            </v-progress-circular>
            
            <div class="text-h6 mb-2">{{ statusEnvio }}</div>
            <div class="text-body-2 text-grey">{{ detalhesEnvio }}</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { whatZapService } from "@/services/whatZapService";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: 'WhatzapOpcoes',
  
  data() {
    return {
      loadingDialog: false,
      mensagemDialog: "Carregando dados...",
      retornoApi: null,
      qrCodeDialog: false,
      qrCodeImage: null,
      tempoRestante: 60, // Aumentado para 60 segundos
      timerQRCode: null,
      timerVerificacao: null, // Timer para verificar conexão a cada 10s
      // Mensagem de Teste
      dialogMensagemTeste: false,
      enviandoMensagem: false,
      mensagemTeste: {
        telefone: '',
        texto: '🧪 Teste de mensagem WhatsApp\n\nSe você recebeu esta mensagem, o sistema está funcionando corretamente!'
      },
      resultadoEnvio: null,
      // Progresso de Envio
      dialogProgressoEnvio: false,
      progressoEnvio: 0,
      statusEnvio: '',
      detalhesEnvio: ''
    };
  },

  beforeUnmount() {
    if (this.timerQRCode) {
      clearInterval(this.timerQRCode);
    }
    if (this.timerVerificacao) {
      clearInterval(this.timerVerificacao);
    }
  },

  methods: {
    voltaraomenu() {
      this.$router.push({ name: "MenuDefault" }).catch(() => {});
    },

    // ========================================
    // MÉTODOS DA API
    // ========================================

    async verificarStatus() {
      try {
        this.loadingDialog = true;
        this.mensagemDialog = "Verificando Status...";

        const response = await whatZapService.verificarStatusWhatsapp({
          empresa_id: 1
        });

        if (response?.data?.response?.instance) {
          const instanceInfo = response.data.response.instance;
          this.retornoApi = {
            nomeInstancia: instanceInfo.instanceName,
            statusConexao: instanceInfo.state,
            dadosCompletos: response.data
          };
          toast.success(`Status: ${this.getInstanceStatusText(instanceInfo.state)}`);
        } else {
          throw new Error("Resposta inválida da API");
        }
      } catch (error) {
        console.error("Erro ao verificar status:", error);
        this.retornoApi = { 
          erro: "Erro ao buscar status da instância.",
          detalhes: error.message 
        };
        toast.error("Erro ao verificar status");
      } finally {
        this.loadingDialog = false;
      }
    },

    async verificarInstanciasGeral() {
      try {
        this.loadingDialog = true;
        this.mensagemDialog = "Consultando instâncias...";

        const response = await whatZapService.verificarInstanciasGeral({
          empresa_id: 1
        });

        if (response?.data) {
          this.retornoApi = {
            instancias: this.processarInstancias(response.data),
            dadosCompletos: response.data,
            timestamp: new Date().toISOString()
          };
          toast.success(`${this.retornoApi.instancias.length} instância(s) encontrada(s)`);
        } else {
          this.retornoApi = { 
            instancias: [],
            erro: "Nenhuma instância encontrada" 
          };
          toast.warning("Nenhuma instância encontrada");
        }
      } catch (error) {
        console.error("Erro ao consultar instâncias:", error);
        this.retornoApi = { 
          instancias: [],
          erro: "Erro ao consultar instâncias.",
          detalhes: error.message 
        };
        toast.error("Erro ao consultar instâncias");
      } finally {
        this.loadingDialog = false;
      }
    },

    async desconectarInstancia() {
      try {
        this.loadingDialog = true;
        this.mensagemDialog = "Desconectando instância...";

        const response = await whatZapService.desconectarWhatsapp({
          empresa_id: 1
        });

        if (response?.data?.status === 'sucesso') {
          this.retornoApi = {
            acao: "Instância desconectada com sucesso!",
            proximoPasso: "Agora você pode gerar um novo QR Code",
            statusConexao: "close",
            dadosCompletos: response.data
          };
          toast.success("Instância desconectada com sucesso!");
        } else {
          throw new Error("Erro ao desconectar instância");
        }
      } catch (error) {
        console.error("Erro ao desconectar instância:", error);
        this.retornoApi = { 
          erro: "Erro ao desconectar instância.",
          detalhes: error.message 
        };
        toast.error("Erro ao desconectar instância");
      } finally {
        this.loadingDialog = false;
      }
    },

    async gerarQRCode() {
      try {
        // ✅ VERIFICAR SE JÁ ESTÁ CONECTADO PRIMEIRO
        this.loadingDialog = true;
        this.mensagemDialog = "Verificando status...";

        const statusResponse = await whatZapService.verificarStatusWhatsapp({
          empresa_id: 1
        });

        const status = statusResponse?.data?.response?.instance?.state;

        // ✅ SE JÁ ESTÁ CONECTADO, AVISAR O USUÁRIO
        if (status === 'open') {
          this.loadingDialog = false;
          toast.warning("⚠️ WhatsApp já está conectado! Desconecte primeiro para gerar um novo QR Code.");
          return;
        }

        // ✅ SE NÃO ESTÁ CONECTADO, GERAR QR CODE
        this.mensagemDialog = "Gerando QR Code...";

        const response = await whatZapService.gerarQrcode({
          empresa_id: 1
        });

        this.retornoApi = response?.data || {};

        let qrCodeBase64 = null;
        
        if (response?.data?.qrcode) {
          qrCodeBase64 = response.data.qrcode;
        } else if (response?.data?.resposta?.base64) {
          qrCodeBase64 = response.data.resposta.base64;
        }

        if (qrCodeBase64) {
          this.mensagemDialog = "Processando QR Code...";
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          this.loadingDialog = false;
          this.qrCodeImage = qrCodeBase64;
          this.qrCodeDialog = true;
          this.iniciarTimerQRCode();
          toast.success("QR Code gerado! Escaneie com seu WhatsApp");
        } else {
          throw new Error("QR Code não encontrado na resposta da API");
        }
      } catch (error) {
        console.error("Erro ao gerar QR Code:", error);
        this.retornoApi = {
          erro: "Erro ao gerar QR Code",
          detalhes: error.message
        };
        toast.error("Erro ao gerar QR Code");
        this.mensagemDialog = "Erro ao gerar QR Code. Tente novamente.";
        setTimeout(() => {
          this.loadingDialog = false;
        }, 1500);
      }
    },

    // ========================================
    // MÉTODOS PARA INSTÂNCIAS
    // ========================================

    processarInstancias(data) {
      let instancias = [];

      if (Array.isArray(data)) {
        instancias = data;
      } else if (data.instances && Array.isArray(data.instances)) {
        instancias = data.instances;
      } else if (data.response && Array.isArray(data.response)) {
        instancias = data.response;
      } else if (data.data && Array.isArray(data.data)) {
        instancias = data.data;
      } else if (typeof data === 'object') {
        const possibleInstances = Object.values(data).filter(item => 
          typeof item === 'object' && 
          (item.instanceName || item.state || item.instanceId)
        );
        if (possibleInstances.length > 0) {
          instancias = possibleInstances;
        }
      }

      return instancias.map((instancia, index) => ({
        ...instancia,
        lastUpdate: new Date().toISOString(),
        instanceName: instancia.instanceName || instancia.name || `Instância ${index + 1}`
      }));
    },

    getInstanceColor(state) {
      const colorMap = {
        'open': 'success',
        'connecting': 'warning',
        'close': 'error',
        'qr': 'info',
        'starting': 'orange',
        'stopping': 'red-darken-1'
      };
      return colorMap[state] || 'grey';
    },

    getInstanceIcon(state) {
      const iconMap = {
        'open': 'mdi-check-circle',
        'connecting': 'mdi-loading',
        'close': 'mdi-close-circle',
        'qr': 'mdi-qrcode',
        'starting': 'mdi-play-circle',
        'stopping': 'mdi-stop-circle'
      };
      return iconMap[state] || 'mdi-help-circle';
    },

    getInstanceStatusText(state) {
      const statusMap = {
        'open': 'Conectado',
        'connecting': 'Conectando',
        'close': 'Desconectado',
        'qr': 'QR Pendente',
        'starting': 'Iniciando',
        'stopping': 'Parando'
      };
      return statusMap[state] || state || 'Desconhecido';
    },

    getInstanceCardClass(state) {
      const classMap = {
        'open': 'instance-card-success',
        'connecting': 'instance-card-warning',
        'close': 'instance-card-error',
        'qr': 'instance-card-info'
      };
      return classMap[state] || 'instance-card-default';
    },

    formatServerUrl(url) {
      if (!url) return 'N/A';
      try {
        const urlObj = new URL(url);
        return urlObj.hostname;
      } catch {
        return url.substring(0, 30) + (url.length > 30 ? '...' : '');
      }
    },

    formatPhoneNumber(number) {
      if (!number) return 'N/A';
      const cleaned = number.replace(/\D/g, '');
      if (cleaned.length === 13 && cleaned.startsWith('55')) {
        return `+55 (${cleaned.substring(2, 4)}) ${cleaned.substring(4, 9)}-${cleaned.substring(9)}`;
      }
      return number;
    },

    formatTimestamp(timestamp) {
      if (!timestamp) return '';
      try {
        return new Date(timestamp).toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch {
        return timestamp;
      }
    },

    async conectarInstancia(instancia) {
      try {
        this.loadingDialog = true;
        this.mensagemDialog = `Conectando ${instancia.instanceName}...`;

        await this.gerarQRCode();
        toast.success(`Iniciando conexão da instância ${instancia.instanceName}`);
      } catch (error) {
        console.error("Erro ao conectar instância:", error);
        toast.error("Erro ao conectar instância");
      } finally {
        this.loadingDialog = false;
      }
    },

    async desconectarInstanciaEspecifica(instancia) {
      try {
        this.loadingDialog = true;
        this.mensagemDialog = `Desconectando ${instancia.instanceName}...`;

        await this.desconectarInstancia();
        toast.success(`Instância ${instancia.instanceName} desconectada`);
      } catch (error) {
        console.error("Erro ao desconectar instância:", error);
        toast.error("Erro ao desconectar instância");
      } finally {
        this.loadingDialog = false;
      }
    },

    async verificarStatusInstancia(instancia) {
      try {
        this.loadingDialog = true;
        this.mensagemDialog = `Verificando ${instancia.instanceName}...`;

        await this.verificarStatus();
        toast.info(`Status da instância ${instancia.instanceName} atualizado`);
      } catch (error) {
        console.error("Erro ao verificar instância:", error);
        toast.error("Erro ao verificar instância");
      } finally {
        this.loadingDialog = false;
      }
    },

    // ========================================
    // MÉTODOS AUXILIARES
    // ========================================

    iniciarTimerQRCode() {
      this.tempoRestante = 60; // 60 segundos
      
      // Limpar timers anteriores
      if (this.timerQRCode) {
        clearInterval(this.timerQRCode);
      }
      if (this.timerVerificacao) {
        clearInterval(this.timerVerificacao);
      }
      
      // Timer de contagem regressiva (1 segundo)
      this.timerQRCode = setInterval(() => {
        this.tempoRestante--;
        if (this.tempoRestante <= 0) {
          this.fecharQRCode();
          toast.warning("QR Code expirado. Gere um novo!");
        }
      }, 1000);

      // Timer de verificação de conexão (10 segundos)
      this.timerVerificacao = setInterval(async () => {
        try {
          console.log("🔍 Verificando conexão automaticamente...");
          
          const response = await whatZapService.verificarStatusWhatsapp({
            empresa_id: 1
          });

          const status = response?.data?.response?.instance?.state;
          console.log("📱 Status atual:", status);

          if (status === 'open') {
            // ✅ CONECTADO! Fechar QR Code e mostrar sucesso
            this.fecharQRCode();
            
            // Atualizar status na tela
            this.retornoApi = {
              nomeInstancia: response.data.response.instance.instanceName,
              statusConexao: status,
              dadosCompletos: response.data
            };

            toast.success("🎉 WhatsApp conectado com sucesso!");
          }
        } catch (error) {
          console.error("Erro ao verificar status:", error);
        }
      }, 10000); // Verificar a cada 10 segundos
    },

    fecharQRCode() {
      // Limpar ambos os timers
      if (this.timerQRCode) {
        clearInterval(this.timerQRCode);
        this.timerQRCode = null;
      }
      if (this.timerVerificacao) {
        clearInterval(this.timerVerificacao);
        this.timerVerificacao = null;
      }
      
      this.qrCodeDialog = false;
      this.qrCodeImage = null;
      this.tempoRestante = 60;
    },

    getStatusColor(status) {
      const statusMap = {
        'open': 'success',
        'connecting': 'warning',
        'close': 'error',
        'qr': 'info'
      };
      return statusMap[status] || 'grey';
    },

    getStatusIcon(status) {
      const iconMap = {
        'open': 'mdi-check-circle',
        'connecting': 'mdi-loading',
        'close': 'mdi-close-circle',
        'qr': 'mdi-qrcode'
      };
      return iconMap[status] || 'mdi-help-circle';
    },

    // ========================================
    // NOVOS MÉTODOS
    // ========================================

    async resetarInstancia() {
      try {
        this.loadingDialog = true;
        this.mensagemDialog = "Resetando instância...";

        // 1. Desconectar
        await this.desconectarInstancia();
        
        // 2. Aguardar 2 segundos
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        // 3. Gerar novo QR Code
        await this.gerarQRCode();
        
        toast.success("Instância resetada! Escaneie o novo QR Code");
      } catch (error) {
        console.error("Erro ao resetar instância:", error);
        toast.error("Erro ao resetar instância");
      } finally {
        this.loadingDialog = false;
      }
    },

    abrirDialogMensagemTeste() {
      if (this.retornoApi?.statusConexao !== 'open') {
        toast.warning("Conecte o WhatsApp primeiro!");
        return;
      }
      this.dialogMensagemTeste = true;
      this.resultadoEnvio = null;
    },

    fecharDialogMensagemTeste() {
      this.dialogMensagemTeste = false;
      this.mensagemTeste.telefone = '';
      this.mensagemTeste.texto = '🧪 Teste de mensagem WhatsApp\n\nSe você recebeu esta mensagem, o sistema está funcionando corretamente!';
      this.resultadoEnvio = null;
    },

    async enviarMensagemTeste() {
      try {
        this.enviandoMensagem = true;
        this.resultadoEnvio = null;

        // Validações
        if (!this.mensagemTeste.telefone || !this.mensagemTeste.texto) {
          toast.error("Preencha todos os campos!");
          return;
        }

        // Mostrar progresso
        this.dialogProgressoEnvio = true;
        this.progressoEnvio = 0;
        this.statusEnvio = "Verificando conexão...";
        this.detalhesEnvio = "Aguarde...";

        // Simular progresso
        this.progressoEnvio = 20;

        // Verificar status primeiro
        const statusResponse = await whatZapService.verificarStatusWhatsapp({
          empresa_id: 1
        });

        this.progressoEnvio = 40;
        this.statusEnvio = "Enviando mensagem...";

        const status = statusResponse?.data?.response?.instance?.state;
        if (status !== 'open') {
          throw new Error("WhatsApp não está conectado!");
        }

        this.progressoEnvio = 60;

        // Enviar mensagem
        const response = await whatZapService.enviarWhatsapp({
          telefone: this.mensagemTeste.telefone,
          texto: this.mensagemTeste.texto,
          empresa_id: 1
        });

        this.progressoEnvio = 100;
        this.statusEnvio = "Mensagem enviada!";
        this.detalhesEnvio = "Verifique seu WhatsApp";

        // Aguardar 1 segundo para mostrar o sucesso
        await new Promise(resolve => setTimeout(resolve, 1000));

        this.dialogProgressoEnvio = false;

        // Mostrar resultado
        this.resultadoEnvio = {
          tipo: 'success',
          titulo: '✅ Mensagem Enviada!',
          mensagem: `Mensagem enviada para ${this.mensagemTeste.telefone}. Verifique seu WhatsApp!`
        };

        toast.success("Mensagem enviada com sucesso!");

      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        
        this.dialogProgressoEnvio = false;
        
        this.resultadoEnvio = {
          tipo: 'error',
          titulo: '❌ Erro no Envio',
          mensagem: error.message || 'Erro ao enviar mensagem. Verifique a conexão e tente novamente.'
        };

        toast.error("Erro ao enviar mensagem");
      } finally {
        this.enviandoMensagem = false;
      }
    }
  }
};
</script>

<style scoped>
.whatsapp-config-container {
  padding: 24px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  min-height: 100vh;
}

.page-header {
  margin-bottom: 24px;
}

.back-btn {
  font-weight: 600;
  border-radius: 8px;
}

.main-card {
  border-radius: 12px;
  overflow: hidden;
}

.action-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 12px;
  height: 100%;
}

.action-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.status-card:hover {
  border-color: #2196f3;
}

.instances-card:hover {
  border-color: #1976d2;
}

.disconnect-card:hover,
.qr-card:hover,
.qr-extra-card:hover {
  border-color: #4caf50;
}

.connecting-card {
  opacity: 0.7;
  cursor: not-allowed;
}

.result-card {
  border-radius: 12px;
  overflow: hidden;
}

.status-item {
  border-left: 3px solid #e0e0e0;
  padding-left: 12px;
}

.json-container {
  background: #fafafa;
  border-radius: 8px;
}

.json-content {
  font-family: 'Courier New', monospace;
  font-size: 0.875rem;
  line-height: 1.4;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 400px;
  overflow-y: auto;
}

.loading-card {
  border-radius: 16px;
}

.qr-modal {
  border-radius: 16px;
  overflow: hidden;
}

.qr-container {
  max-width: 350px;
  margin: 0 auto;
}

.qr-image {
  width: 100%;
  max-width: 300px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.timer-section {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
}

.instances-display-card {
  border-radius: 12px;
  overflow: hidden;
}

.instance-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  height: 100%;
}

.instance-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.instance-card-success {
  border-left: 4px solid #4caf50;
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.02), rgba(76, 175, 80, 0.05));
}

.instance-card-warning {
  border-left: 4px solid #ff9800;
  background: linear-gradient(135deg, rgba(255, 152, 0, 0.02), rgba(255, 152, 0, 0.05));
}

.instance-card-error {
  border-left: 4px solid #f44336;
  background: linear-gradient(135deg, rgba(244, 67, 54, 0.02), rgba(244, 67, 54, 0.05));
}

.instance-card-info {
  border-left: 4px solid #2196f3;
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.02), rgba(33, 150, 243, 0.05));
}

.instance-card-default {
  border-left: 4px solid #9e9e9e;
  background: linear-gradient(135deg, rgba(158, 158, 158, 0.02), rgba(158, 158, 158, 0.05));
}

.mdi-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .whatsapp-config-container {
    padding: 16px;
  }
  
  .page-header .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 16px;
  }
  
  .back-btn {
    align-self: stretch;
  }
  
  .action-card,
  .instance-card {
    margin-bottom: 16px;
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.action-card {
  animation: slideInUp 0.3s ease;
}

.action-card:nth-child(1) { animation-delay: 0.1s; }
.action-card:nth-child(2) { animation-delay: 0.2s; }
.action-card:nth-child(3) { animation-delay: 0.3s; }

.instance-card {
  animation: fadeInUp 0.4s ease;
}

.instance-card:nth-child(1) { animation-delay: 0.1s; }
.instance-card:nth-child(2) { animation-delay: 0.2s; }
.instance-card:nth-child(3) { animation-delay: 0.3s; }
.instance-card:nth-child(4) { animation-delay: 0.4s; }

.action-card[loading="true"] {
  pointer-events: none;
  opacity: 0.7;
}
</style>